import { render, staticRenderFns } from "./SiteTreeNavigationMenu.vue?vue&type=template&id=6aadaeb1&scoped=true"
import script from "./SiteTreeNavigationMenu.vue?vue&type=script&lang=js"
export * from "./SiteTreeNavigationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aadaeb1",
  null
  
)

export default component.exports